import React, { useEffect, useState, useRef } from 'react';
import './Timer.scss'; // Optional: For styling

const Timer = ({ phone }) => {
  const [time, setTime] = useState(55000); // 55,000ms = 55 seconds
  const intervalRef = useRef(null); // Store the interval ID

  useEffect(() => {
    // Start the timer with correct interval
    intervalRef.current = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 100; // Decrease by 100ms per tick
        } else {
          clearInterval(intervalRef.current);
          return 0; // Ensure it doesn't go below 0
        }
      });
    }, 100); // Correct interval: 100ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, []);

  // Calculate minutes, seconds, and tenths of seconds
  const minutes = Math.floor((time / 60000) % 60);
  const seconds = Math.floor((time / 1000) % 60);
  const tenths = Math.floor((time % 1000) / 100); // 0-9 tenths of seconds

  // Format time with leading zeros
  const formatTime = (unit) => String(unit).padStart(2, '0');

  return (
    <div className="timer-container">
      <p>We are calling you at {phone}</p>
      <h1>
        <span>
        {formatTime(minutes)}:{formatTime(seconds)}:{formatTime(tenths)}
        </span>
      </h1>
      <div className="labels">
        <span>min</span>
        <span>sec</span>
        <span>ms</span>
      </div>
    </div>
  );
};

export default Timer;
